export { default, getServerSideProps } from './Results';
